export default __webpack_public_path__ + "3cd5f7d3975fd7cf00f7100c4528fd22.wasm";